// DEFAULTS
// require('angular/customer_application_bootstrap/angular/components/personal');
require('angular/customer_application_bootstrap/angular/components/rates_terms');
require('angular/customer_application_bootstrap/angular/components/contract');
require('angular/customer_application_bootstrap/angular/components/bank_account');
require('angular/customer_application_bootstrap/angular/components/additional_information');
// require('angular/customer_application_bootstrap/angular/components/declined');
require('angular/customer_application_bootstrap/angular/components/vehicle');

// PARTNER SPECIFIC OVERRIDES
require('./personal');
require('./declined');
